import { Theme } from '@chakra-ui/react'

type Params = {
  theme: Theme
  colorMode: 'light' | 'dark'
}

const Form = {
  parts: ['container', 'label', 'requiredIndicator', 'helperText'],
  baseStyle: ({ colorMode, theme }: Params) => {
    return {
      container: {},
      helperText: {
        fontWeight: 500,
        lineHeight: '115%',
        color: theme.colors.gray[colorMode === 'light' ? 500 : 400],
        marginBottom: 2,
        fontSize: 'xs',
      },
      label: {
        m: 0,
      },
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {},
}

export default Form
